import React from "react";
import { API_SERVICES, HandleApi } from "../contants/general.constants";
import { Card } from "./card/card";

const FALLBACK_SERVICES = [
 {
  title: "Web Development",
  text: "Modern, scalable web applications — from marketing sites to complex platforms, built with clean architecture and performance in mind.",
  icon: "fa-solid fa-code",
 },
 {
  title: "Mobile Apps",
  text: "Native-quality mobile experiences for iOS and Android that your users will love, shipped fast without cutting corners.",
  icon: "fa-solid fa-mobile-screen",
 },
 {
  title: "AI & Machine Learning",
  text: "Practical AI solutions — from data pipelines to intelligent features — that turn your data into a competitive advantage.",
  icon: "fa-solid fa-brain",
 },
 {
  title: "Cloud & DevOps",
  text: "Reliable infrastructure, CI/CD, and cloud-native deployments so your software runs securely and scales effortlessly.",
  icon: "fa-solid fa-cloud",
 },
];

export function ServicesComponent() {
 const [services, setServices] = React.useState(null);

 HandleApi(API_SERVICES, setServices, setServices);

 const cardContent = {
  header: "Services",
  key: "services",
  description: "Delivering cutting-edge software solutions: your digital success, our priority.",
  content: [],
 };

 if (services) {
  const results = services.results.filter((service) => service.name);
  cardContent.content = results.length
   ? results.map((service) => ({ title: service.name, text: service.description, icon: service.icon }))
   : FALLBACK_SERVICES;
 }

 return <Card key="services" props={{ card: cardContent, id: "services" }} />;
}
